<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix">
      <div id="main_area">
      <div class="information">
      <h3>{{pageData.MenuName}}</h3>
      <div class="table_scroll2">
        <table class="newTable">
          <tbody>
            <tr>
              <td>土地</td>
              <td>
                面積相差
                <input type="text" v-model="form.land" maxlength="9" />平方公尺
              </td>
            </tr>
            <tr>
              <td>建物</td>
              <td>
                主要面積相差
                <input type="text" v-model="form.building1" maxlength="9" />
                平方公尺
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                共同面積相差
                <input type="text" v-model="form.building2" maxlength="9" />
                平方公尺
              </td>
            </tr>
            <tr>
              <td>汽車</td>
              <td>
                汽缸容量相差
                <input type="text" v-model="form.vehicle" maxlength="9"/>
                CC
              </td>
            </tr>
            <tr>
              <td>存款</td>
              <td>
                金額相差
                <input type="text" v-model="form.deposit" maxlength="9"/>
                元
              </td>
            </tr>
            <tr>
              <td>有價證券</td>
              <td>
                單位相差
                <input type="text" v-model="form.stocknbond" maxlength="9"/>
                單位
              </td>
            </tr>
            <tr>
              <td>其他財產</td>
              <td>
                金額相差
                <input type="text" v-model="form.misc" maxlength="9"/>
                元
              </td>
            </tr>
            <tr>
              <td>債權</td>
              <td>
                金額相差
                <input type="text" v-model="form.credit" maxlength="9"/>
                元
              </td>
            </tr>
            <tr>
              <td>債務</td>
              <td>
                金額相差
                <input type="text" v-model="form.debit" maxlength="9"/>
                元
              </td>
            </tr>
            <tr>
              <td>事業投資</td>
              <td>
                <p>
                  金額相差
                  <input type="text" v-model="form.investment" maxlength="9"/>
                  元
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnSettingVerifyConfig()"
                    /> </span
                ></label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="f_center"></div>
    </div>
      </div>
    </div>

    <PdisFooter />
    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex,getMenu } from "@/config/util.js";
import {
  F203_SearchVerifyConfig,
  F203_SettingVerifyConfig,
} from "@/service/api.js";
export default {
  name: "F203",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F203",
        ServiceUnit: "PDIS",
        isForceLoginOut : true,
      },
      loginInfo : JSON.parse(sessionStorage.getItem("LoginInfo")) ? JSON.parse(sessionStorage.getItem("LoginInfo")) : "",
      form:{
        land: "",
        //建物-主要面積
        building1: "",
        //建物-共同面積
        building2: "",
        //存款
        deposit: "",
        //有價證券
        stocknbond: "",
        //其他財產
        misc: "",
        //債權
        credit: "",
        //債務
        debit: "",
        //事業投資
        investment: "",
        vehicle: "",
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
  },
  methods:{
    getSearchVerifyConfig: function(){
      const self = this;
      if(self.loginInfo){
        let postData = {
          goV_CODE: self.loginInfo.govCode
        }
        F203_SearchVerifyConfig(postData).then(rData => {
          console.log(rData);
          if(rData.returnObject){
            self.form = rData.returnObject;
          }
        });
      }
    },
    btnSettingVerifyConfig: function() {
      const self = this;
      if(self.loginInfo){
        let postData = {
          goV_CODE: self.loginInfo.govCode,
          land: self.form.land,
          building1: self.form.building1,
          building2: self.form.building2,
          deposit: self.form.deposit,
          stocknbond: self.form.stocknbond,
          misc: self.form.misc,
          credit: self.form.credit,
          debit: self.form.debit,
          investment: self.form.investment,
          vehicle: self.form.vehicle,
          LogInfo:{
            Id:self.loginInfo.id,
            PrgCode:self.pageData.PrgName,
            ActCd:"存檔",
            ServiceUnit:self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          }
        };
        F203_SettingVerifyConfig(postData).then(rData => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["實質審核誤差值設定成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["實質審核誤差值設定錯誤"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
  },
  created(){
    const self = this;
    //教育部的部分新系統後台請維持先前作法，以系統寫死六組之方式
    if(self.loginInfo && self.loginInfo.govCodeStr.split(',')[0] === '309000000E'){
      switch(self.loginInfo.govCode)
      {
        case "309000000E":
        case "309000100E":
        case "A09000000E":
        case "A09010000E":
        case "A09020000E":
        case "309130000E":
        case "309190000E":
          break;
        default:
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.$router.go(-1);
          };
          break;
      }
    }
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.getSearchVerifyConfig();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
